import type { AnalyticsEvent } from "./analytics-events";
import { ensureAnalyticsReady } from "./posthog-client";

/**
 * Fire-and-forget: never throws, never blocks the caller. Awaits the same
 * readiness gate as identify() so a call made before PostHog finishes loading
 * queues behind that promise instead of being dropped.
 */
export const trackEvent = (
  event: AnalyticsEvent,
  properties?: Record<string, unknown>
): void => {
  ensureAnalyticsReady().then((ready) => {
    if (ready) window.posthog?.capture(event, properties);
  });
};
